import { type UseQueryResult, useQuery } from 'react-query';
import { CompantTypeService } from '../../services/wealthlane-identity-services/services/CompantTypeService';
import { BrokerService } from '../../services/wealthlane-customer-services';

const useGetBrokerOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string | null | undefined;
      value: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const brokerOptions = useQuery(
    ['getBrokerOptions'],
    async () => {
      return await handleRequest(BrokerService.getApiCustomerBrokerOptions());
    },
    {
      select(data) {
        return data?.map((item) => {
          return {
            label: item.name,
            value: item.companyId,
          };
        });
      },
    }
  );

  return brokerOptions;
};

export default useGetBrokerOptions;
